(()=>{

  var start = () => {
    /* Lets make the details element of the drawer menu slide down with animation */
    /* https://stackoverflow.com/questions/21343744/make-the-contents-of-a-details-tag-animate-when-open-with-jquery-js */
    $('.jci-header--drawer-menu details > summary').each(function() { 
      var $Wrapper = $(this).nextAll();
   
      if(!$(this).parent('details').attr('open'))
         $Wrapper.hide();
      $(this).click(function(Event) {
         Event.preventDefault();
         if($(this).parent('details').attr('open')) {
            $Wrapper.slideUp(350, function() {
               $(this).parent('details').removeAttr('open');
            });
         } else {

            $(this.closest('.jci-header--drawer-menu')).find('details').each(function() {
              if ($(this).attr('open')) {
                $(this.querySelector('.jci-header--drawer-menu details > summary + *')).slideUp(350, function() {
                   $(this).parent('details').removeAttr('open');
                  debugger;
                });
              }
            });
            
            $(this).parent('details').attr('open', true);
            $Wrapper.slideDown(350);
         }
      });
    });
  };
   

  var waitForJQuery = function () {
    if (typeof $ != "undefined") {
      //console.log("jquery loaded..");
      start(); 
    } else {
      //console.log("jquery not loaded..");
      window.setTimeout(waitForJQuery, 50);
    }
  };
  waitForJQuery();

})();
